// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-sidenav {
  width: 220px;
  height: 100vh;
  position: fixed;
  top: 38px; /* adjust as needed for your header */
  left: 0;
  background: #fff;
  border-right: 1px solid #eee;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.03);
  z-index: 900;
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateX(0);
  overflow: hidden;
}

.custom-sidenav.hidden {
  transform: translateX(-220px);
  pointer-events: none;
}

.custom-sidenav .nav-item {
  padding: 14px 24px;
  color: #333;
  text-decoration: none;
  font-weight: 500;
  border-left: 3px solid transparent;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.custom-sidenav .nav-item.active {
  background: rgba(214, 64, 0, 0.1);
  border-left: 3px solid #d64000;
  color: #d64000;
  transform: translateX(4px);
}

.custom-sidenav .nav-item:hover {
  background: #f5f5f5;
  transform: translateX(2px);
}

/* Add a subtle slide-in animation for nav items */
.custom-sidenav .nav-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}

.custom-sidenav .nav-item:hover::before {
  left: 100%;
}

/* Container for smooth slide animation */
.sidenav-container {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateX(0);
}

.sidenav-container.hidden {
  transform: translateX(-220px);
}
`, "",{"version":3,"sources":["webpack://./src/css/custom-sidenav.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,SAAS,EAAE,qCAAqC;EAChD,OAAO;EACP,gBAAgB;EAChB,4BAA4B;EAC5B,yCAAyC;EACzC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,uDAAuD;EACvD,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;EAClC,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA,yCAAyC;AACzC;EACE,iDAAiD;EACjD,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".custom-sidenav {\n  width: 220px;\n  height: 100vh;\n  position: fixed;\n  top: 38px; /* adjust as needed for your header */\n  left: 0;\n  background: #fff;\n  border-right: 1px solid #eee;\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.03);\n  z-index: 900;\n  display: flex;\n  flex-direction: column;\n  padding-top: 16px;\n  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translateX(0);\n  overflow: hidden;\n}\n\n.custom-sidenav.hidden {\n  transform: translateX(-220px);\n  pointer-events: none;\n}\n\n.custom-sidenav .nav-item {\n  padding: 14px 24px;\n  color: #333;\n  text-decoration: none;\n  font-weight: 500;\n  border-left: 3px solid transparent;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.custom-sidenav .nav-item.active {\n  background: rgba(214, 64, 0, 0.1);\n  border-left: 3px solid #d64000;\n  color: #d64000;\n  transform: translateX(4px);\n}\n\n.custom-sidenav .nav-item:hover {\n  background: #f5f5f5;\n  transform: translateX(2px);\n}\n\n/* Add a subtle slide-in animation for nav items */\n.custom-sidenav .nav-item::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n  transition: left 0.5s ease;\n}\n\n.custom-sidenav .nav-item:hover::before {\n  left: 100%;\n}\n\n/* Container for smooth slide animation */\n.sidenav-container {\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translateX(0);\n}\n\n.sidenav-container.hidden {\n  transform: translateX(-220px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
